import { compose } from 'recompose';
import SRNDetail from './Detail';
import { query } from './API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const composedSrnDetail = compose(withRequestTracker({ query }))(SRNDetail);
export default composedSrnDetail;
